import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
 
import * as html2pdf from 'html2pdf.js';
import { environment } from '@app-environments/environment';
import { TestlistService } from '@app-services/test/testlist.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-score-test-report',
  templateUrl: './score-test-report.component.html',
  styleUrls: ['./score-test-report.component.scss']
})
export class ScoreTestReportComponent implements OnInit {
  @Output() downloadCertificateEmitter= new EventEmitter<any>();
  constructor(private route: ActivatedRoute,
    public AppService: TestlistService, private spinner: NgxSpinnerService) { }
  public Params: any = {}
  testUtility: any = {
    testResponse: {},
    userDetails: {},
    showdownloadReport: true,
    gradedetais:{},
    showCerificate:false
  }
  getSecondsinHours =getSecondsinHours;
  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {
      this.Params = params;
      this.spinner.show();
      Promise.all([this.getTestRecord(),this.getUserDetails()]).then(()=>{
      // this.downloadReport()
      this.testUtility.showCerificate = true;
      this.spinner.hide();
      }).catch((err)=>this.spinner.hide());
    })
  }
  getTestRecord() {
    var promise  = new Promise((resolve,reject)=>{
    this.AppService.scoreTestReport(this.Params).subscribe((resp: any) => {
      resp.examsubmitDate = new Date(resp?.examSubmittedOn)
      this.testUtility.testResponse = resp;
      this.testUtility.gradedetais = environment.UAM_TO_CMS_CONVERSION?.find(v => v?.CMS_Exam_id == resp?.examtype && v?.CMS_grade_id == resp?.grade )
      resolve(true)
    })
    })
    return promise; 
  }
  downloadReport() {
    this.testUtility.showdownloadReport = false;
        setTimeout(() => {
          html2pdf().from(document.getElementsByTagName('body')?.[0]).set({
            filename: ` ${this.Params?.phone}.pdf`,
            image: { type: 'jpeg', quality: 1 },
            margin: 0,
            pagebreak: { mode: 'legacy' },
            jsPDF: { orientation: 'portrait', unit: 'in' }
          }).save()
        }, 100)
        setTimeout(() => {
          this.testUtility.showdownloadReport = true;
        }, 1500);
    
   
  }
  getUserDetails() {
    var promise = new Promise((resolve,reject)=>{
       let body = {
      "phone": this.Params?.phone
    }
    this.AppService.getUserDetails(body).subscribe((resp) => {
      this.testUtility.userDetails = resp?.[0];
      resolve(true)
    })
    })
   return promise;
  }
  downloadCertificateEvent(){
    this.downloadCertificateEmitter.emit(true)
  }
}
export function getSecondsinHours(totalVisitedTime){
  if(totalVisitedTime){

    let testdate: any = new Date(null);
      testdate.setSeconds(totalVisitedTime);
      testdate = testdate.toISOString().substr(11, 8);
      return `${testdate.substring(0,testdate.indexOf(':'),)}h ${testdate.substring(testdate.indexOf(':') + 1,testdate.lastIndexOf(':'),)}m ${testdate.substring(testdate.lastIndexOf(':') + 1, testdate.length)}s`
  }else{
    return 'N/A'
  }
}